import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const APP_VERSION =
  process.env.NODE_ENV === "development"
    ? "dev"
    : process.env.REACT_APP_VERSION;

/**
 * 强制清理 + 重载
 */
function hardReload() {
  console.log("🔄 发现新版本，强制刷新...");

  if (window.caches) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }

  sessionStorage.clear();

  window.location.href = window.location.href.split("?")[0] + "?v=" + Date.now();
}

/**
 * 显示新版本提示条（非侵入式）
 */
function showUpdatePrompt() {
  if (document.getElementById("app-update-prompt")) return;

  const bar = document.createElement("div");
  bar.id = "app-update-prompt";
  bar.style.cssText = `
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    background: #003366;
    color: #fff;
    padding: 12px 16px;
    font-size: 14px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    box-shadow: 0 -2px 8px rgba(0,0,0,0.2);
  `;
  bar.innerHTML = `
    <span>🚀 A new version of the site is available. Please refresh to get the latest content.</span>
    <button style="
      background: #fff;
      color: #003366;
      border: none;
      border-radius: 4px;
      padding: 6px 14px;
      cursor: pointer;
      font-weight: 600;
    ">Refresh</button>
  `;

  bar.querySelector("button").addEventListener("click", () => {
    hardReload();
  });

  document.body.appendChild(bar);
}

/**
 * 初始版本检查：新旧 JS 切换时强制刷新
 */
function checkVersion() {
  const localVersion = sessionStorage.getItem("APP_VERSION");

  if (!localVersion) {
    sessionStorage.setItem("APP_VERSION", APP_VERSION);
    return;
  }

  if (localVersion !== APP_VERSION) {
    sessionStorage.setItem("APP_VERSION", APP_VERSION);
    hardReload();
  }
}

checkVersion();

/**
 * 轮询 version.json，在长时间开着的页面中主动发现服务器更新
 */
function startVersionPolling() {
  if (process.env.NODE_ENV === "development") return;
  if (!APP_VERSION) return;

  const check = async () => {
    try {
      const res = await fetch(`/version.json?t=${Date.now()}`);
      if (!res.ok) return;
      const data = await res.json();
      if (data.version && data.version !== APP_VERSION) {
        showUpdatePrompt();
      }
    } catch (e) {
      // 忽略网络波动或文件不存在
    }
  };

  check();
  setInterval(check, 5 * 60 * 1000); // 每 5 分钟检查一次
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <App key={APP_VERSION} />
);

reportWebVitals();

startVersionPolling();
